'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Constants = require('../Constants');

var _AvatarContentHolder = require('./baseStyledComponents/AvatarContentHolder');

var _AvatarContentHolder2 = _interopRequireDefault(_AvatarContentHolder);

var _AvatarWrapper = require('./baseStyledComponents/AvatarWrapper');

var _AvatarWrapper2 = _interopRequireDefault(_AvatarWrapper);

var _AvatarWrapperOverlay = require('./baseStyledComponents/AvatarWrapperOverlay');

var _AvatarWrapperOverlay2 = _interopRequireDefault(_AvatarWrapperOverlay);

var _icons = require('icons/icons');

var _icons2 = _interopRequireDefault(_icons);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SocialBadge = require('./baseStyledComponents/SocialBadge');

var _SocialBadge2 = _interopRequireDefault(_SocialBadge);

var _SVGIcon = require('./baseStyledComponents/SVGIcon');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _SVGIconEdit = require('./baseStyledComponents/SVGIconEdit');

var _SVGIconEdit2 = _interopRequireDefault(_SVGIconEdit);

var _SVGImage = require('./baseStyledComponents/SVGImage');

var _SVGImage2 = _interopRequireDefault(_SVGImage);

var _SVGText = require('./baseStyledComponents/SVGText');

var _SVGText2 = _interopRequireDefault(_SVGText);

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _UITruncateString = require('UIComponents/text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function delayUntilIdle(callback) {
  var delay = window.requestIdleCallback || window.setTimeout;
  var delayOptions = delay === window.requestIdleCallback ? { timeout: 5000 } : 1000;
  var id = delay(callback, delayOptions);
  return window.requestIdleCallback ? function () {
    return window.cancelIdleCallback(id);
  } : function () {
    return window.clearTimeout(id);
  };
}

var UIAvatarDisplay = function (_Component) {
  _inherits(UIAvatarDisplay, _Component);

  function UIAvatarDisplay(props) {
    _classCallCheck(this, UIAvatarDisplay);

    var _this = _possibleConstructorReturn(this, (UIAvatarDisplay.__proto__ || Object.getPrototypeOf(UIAvatarDisplay)).call(this, props));

    _this.state = { isDropdownMenuOpen: false, isTooltipLoaded: false };
    return _this;
  }

  _createClass(UIAvatarDisplay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.cancelTimeout = delayUntilIdle(function () {
        return _this2.setState({ isTooltipLoaded: true });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.cancelTimeout();
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter() {
      this.setState(function () {
        return { isDropdownMenuOpen: true };
      });
    }
  }, {
    key: 'getDefaultAvatar',
    value: function getDefaultAvatar(type) {
      var _options;

      var options = (_options = {}, _defineProperty(_options, _Constants.AVATAR_TYPES.contact, 'https://static.hsappstatic.net/salesImages/static-1.362/avatars/default-avatar.png'), _defineProperty(_options, _Constants.AVATAR_TYPES.company, 'https://static.hsappstatic.net/salesImages/static-1.362/avatars/default-company-avatar.png'), _options);

      return options[type];
    }
  }, {
    key: 'MaybeAvatarHover',
    value: function MaybeAvatarHover(_ref) {
      var _isHasTooltip = _ref._isHasTooltip,
          _isHoverlayOpen = _ref._isHoverlayOpen,
          _isListReversed = _ref._isListReversed,
          _ref$_isTooltipLoaded = _ref._isTooltipLoaded,
          _isTooltipLoaded = _ref$_isTooltipLoaded === undefined ? false : _ref$_isTooltipLoaded,
          className = _ref.className,
          outerChildren = _ref.outerChildren,
          isHoverlay = _ref.isHoverlay,
          size = _ref.size,
          style = _ref.style,
          toolTipName = _ref.toolTipName,
          toolTipPlacement = _ref.toolTipPlacement,
          rest = _objectWithoutProperties(_ref, ['_isHasTooltip', '_isHoverlayOpen', '_isListReversed', '_isTooltipLoaded', 'className', 'outerChildren', 'isHoverlay', 'size', 'style', 'toolTipName', 'toolTipPlacement']);

      className = className || '';
      className = _isHoverlayOpen ? className + ' hover-test' : className;
      var sizeStyle = size && size !== _Constants.AVATAR_SIZES.responsive ? { width: size + 'px' } : { width: '100%' };
      var calculatedOverlayOffset = { overlapOffset: (size || 40) * 0.15 };
      style = Object.assign({}, style, sizeStyle);

      var AvatarWrapperProps = Object.assign({ _isListReversed: _isListReversed, className: className, style: style }, calculatedOverlayOffset, rest);

      if (!isHoverlay && !_isHoverlayOpen && _isHasTooltip) {
        return outerChildren && !_isTooltipLoaded ? _react2.default.createElement(_AvatarWrapper2.default, AvatarWrapperProps) : _react2.default.createElement(
          _UITooltip2.default,
          { title: toolTipName, placement: toolTipPlacement },
          _react2.default.createElement(_AvatarWrapper2.default, AvatarWrapperProps)
        );
      }

      return _react2.default.createElement(_AvatarWrapperOverlay2.default, AvatarWrapperProps);
    }
  }, {
    key: 'tryToGetANameOutOfEmailAddress',
    value: function tryToGetANameOutOfEmailAddress(aString) {
      if (!aString || !aString.indexOf('@')) {
        return aString;
      }

      return aString.split('_').join(' ');
    }
  }, {
    key: 'isLatinCharacters',
    value: function isLatinCharacters(aString) {
      var nonLatin = /[^\u0000-\u01BF]/;
      return nonLatin.test(aString);
    }
  }, {
    key: 'displayNameToInitials',
    value: function displayNameToInitials(aString, passed) {
      var _props = this.props,
          displayName = _props.displayName,
          _isHasMore = _props._isHasMore,
          _isListReversed = _props._isListReversed,
          size = _props.size,
          type = _props.type;

      if (passed || !aString || typeof aString !== 'string') {
        return _react2.default.createElement(_SVGImage2.default, {
          size: size,
          _isListReversed: _isListReversed,
          src: this.getDefaultAvatar(_Constants.AVATAR_TYPES[type])
        });
      }

      if (!aString || this.isLatinCharacters(aString) && !passed) {
        return this.displayNameToInitials(this.tryToGetANameOutOfEmailAddress(displayName), true);
      }

      var names = aString.split(' ');
      var initials = names[0].substring(0, 1);

      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1);
      }

      return _react2.default.createElement(
        _SVGText2.default,
        { wrapperProps: { _isHasMore: _isHasMore }, y: '55' },
        initials
      );
    }
  }, {
    key: 'renderOverlay',
    value: function renderOverlay() {
      var _this3 = this;

      var _props2 = this.props,
          isHoverlay = _props2.isHoverlay,
          _isHoverlayOpen = _props2._isHoverlayOpen,
          size = _props2.size;

      var isRenderingOverlay = !!isHoverlay || !!_isHoverlayOpen;

      return isRenderingOverlay && _react2.default.createElement(_SVGIconEdit2.default, {
        wrapperProps: {
          onMouseEnter: function onMouseEnter() {
            return _this3.handleMouseEnter();
          },
          onClick: function onClick() {},
          size: size
        },
        size: _Constants.AVATAR_SIZES[size]
      });
    }
  }, {
    key: 'renderAvatarImageOrText',
    value: function renderAvatarImageOrText() {
      var _props3 = this.props,
          src = _props3.src,
          displayName = _props3.displayName,
          type = _props3.type,
          _isHasMore = _props3._isHasMore,
          size = _props3.size;


      if (src) {
        return _react2.default.createElement(_SVGImage2.default, { size: size, src: src });
      }

      if (_Constants.AVATAR_TYPES[type] === _Constants.AVATAR_TYPES.company) {
        return _react2.default.createElement(_SVGImage2.default, {
          size: size,
          src: this.getDefaultAvatar(_Constants.AVATAR_TYPES.company)
        });
      }
      if (_isHasMore || _Constants.AVATAR_TYPES[type] === _Constants.AVATAR_TYPES.contact || _Constants.AVATAR_TYPES[type] === _Constants.AVATAR_TYPES.company) {
        return this.displayNameToInitials(displayName);
      }

      return _react2.default.createElement(_SVGIcon2.default, {
        wrapperProps: { size: size },
        y: 65,
        icon: _icons2.default[_Constants.AVATAR_TYPES[type]]
      });
    }
  }, {
    key: 'renderSocialBadge',
    value: function renderSocialBadge(socialNetwork) {
      if (!socialNetwork) {
        return undefined;
      }
      return _react2.default.createElement(_SocialBadge2.default, { socialNetwork: socialNetwork });
    }
  }, {
    key: 'renderContentAndOverlay',
    value: function renderContentAndOverlay() {
      var _props4 = this.props,
          href = _props4.href,
          _isListReversed = _props4._isListReversed,
          size = _props4.size,
          type = _props4.type;

      return _react2.default.createElement(
        _AvatarContentHolder2.default,
        {
          _isListReversed: _isListReversed,
          size: size,
          href: href,
          type: type
        },
        this.renderAvatarImageOrText(),
        this.renderOverlay()
      );
    }
  }, {
    key: 'renderAvatarContent',
    value: function renderAvatarContent(SwitchComponent, props, socialNetwork) {
      return _react2.default.createElement(
        SwitchComponent,
        props,
        this.renderContentAndOverlay(),
        this.renderSocialBadge(socialNetwork)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var MaybeAvatarHover = this.MaybeAvatarHover,
          props = this.props;
      var _isHasTooltip = props._isHasTooltip,
          _isHasMore = props._isHasMore,
          _isHoverlayOpen = props._isHoverlayOpen,
          _isListReversed = props._isListReversed,
          _toolTipOverWrite = props._toolTipOverWrite,
          className = props.className,
          children = props.children,
          displayName = props.displayName,
          isHoverlay = props.isHoverlay,
          size = props.size,
          socialNetwork = props.socialNetwork,
          style = props.style,
          textSpacing = props.textSpacing,
          truncateLength = props.truncateLength,
          toolTipPlacement = props.toolTipPlacement;


      var maybeWrapperProps = {
        _isHasTooltip: _isHasTooltip,
        _isHasMore: _isHasMore,
        _isHoverlayOpen: _isHoverlayOpen,
        _isListReversed: _isListReversed,
        _isTooltipLoaded: this.state.isTooltipLoaded,
        className: className,
        outerChildren: children,
        displayName: displayName,
        isHoverlay: isHoverlay,
        size: _Constants.AVATAR_SIZES[size],
        style: style,
        toolTipName: _toolTipOverWrite || displayName,
        toolTipPlacement: toolTipPlacement
      };

      var avatarComponent = this.renderAvatarContent(MaybeAvatarHover, maybeWrapperProps, socialNetwork);

      return children ? _react2.default.createElement(
        _UITruncateString2.default,
        { maxWidth: truncateLength },
        _react2.default.createElement(
          'span',
          { className: 'align-center' },
          avatarComponent,
          _react2.default.createElement(
            'span',
            { className: 'm-left-' + textSpacing },
            children
          )
        )
      ) : avatarComponent;
    }
  }]);

  return UIAvatarDisplay;
}(_react.Component);

UIAvatarDisplay.propTypes = {
  _isHasMore: _react.PropTypes.bool,
  _isHasTooltip: _react.PropTypes.bool,
  _isHoverlayOpen: _react.PropTypes.bool,
  _isListReversed: _react.PropTypes.bool,
  _toolTipOverWrite: _react.PropTypes.string,
  className: _react.PropTypes.string,
  displayName: _react.PropTypes.any,
  href: _react.PropTypes.string,
  isHoverlay: _react.PropTypes.bool,
  size: _react.PropTypes.oneOf(Object.keys(_Constants.AVATAR_SIZES)),
  socialNetwork: _react.PropTypes.oneOf(Object.keys(_Constants.SOCIAL_MAP)),
  src: _SVGImage2.default.propTypes.image,
  type: _react.PropTypes.oneOf(Object.keys(_Constants.AVATAR_TYPES)),
  textSpacing: _react.PropTypes.number,
  truncateLength: _react.PropTypes.number,
  toolTipPlacement: _react.PropTypes.string
};

UIAvatarDisplay.defaultProps = {
  _isHasMore: false,
  _isHasTooltip: true,
  _isListReversed: false,
  _isHoverLayOpen: false,
  size: 'sm',
  textSpacing: 3,
  truncateLength: 200
};

exports.default = UIAvatarDisplay;
module.exports = exports['default'];